import { all, select, takeEvery, fork, put, call } from 'redux-saga/effects'

// action
import { customerOrderActions } from '@redux/store/index'

// lib
import { Logger } from '@utils'

// api
import { orderApi, ResType } from '@api'

// schemas
import { Order, CustomerType } from '@schemas'

const apiGetCustomerOrder = async (
	query: {
		customerId: string
	},
	accessToken: string,
): Promise<ResType | undefined> => {
	const customHeaders = { Authorization: `Bearer ${accessToken}` }
	const res: ResType | undefined = await orderApi.getOrderCustomer({
		query: query,
		customHeaders: customHeaders,
	})
	return res
}

function* triggerInitCustomerOrderPageSaga() {
	try {
		const customer: CustomerType = yield select(state => state.customerAuth.customer)

		yield put(customerOrderActions.ORDER_LIST_STATUS('loading'))
		const sessionAccessToken = sessionStorage.getItem('accessCustomerToken')

		if (customer.id !== '' && sessionAccessToken !== null && sessionAccessToken !== '') {
			const query = {
				customerId: customer.id,
			}
			const apiRes: ResType = yield call(apiGetCustomerOrder, query, sessionAccessToken)

			if (apiRes.status === 200) {
				const data = apiRes.data as any[]
				const newOrderList = data.map(aData => new Order(aData))

				yield put(customerOrderActions.ORDER_LIST(newOrderList))
				yield put(customerOrderActions.ORDER_LIST_STATUS('ok'))
			} else {
				yield put(customerOrderActions.ORDER_LIST_STATUS('empty'))
			}
		} else {
			yield put(customerOrderActions.ORDER_LIST_STATUS('empty'))
		}
		yield
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(
		customerOrderActions.TRIGGER_INIT_CUSTOMER_ORDER_PAGE,
		triggerInitCustomerOrderPageSaga,
	)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
